module.exports = __webpack_public_path__ + "static/media/marker-culture.1a12bd7e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/marker-culture.svg
// module id = 175
// module chunks = 0